"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Customer_1 = require("../models/Customer");
var mockCustomer = __assign(__assign({}, Customer_1.makeEmptyCustomer()), { firstName: 'John', lastName: 'Appleseed', gender: 'M', birthday: '20/03/1980', phone: '123456', email: 'johnappleseed@mail.com' });
exports.default = mockCustomer;
//# sourceMappingURL=mockCustomer.js.map